import { render, staticRenderFns } from "./OOverridableNumberField.vue?vue&type=template&id=dd071b80&scoped=true&"
import script from "./OOverridableNumberField.vue?vue&type=script&lang=js&"
export * from "./OOverridableNumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd071b80",
  null
  
)

export default component.exports